import * as cjsm from "invokers-polyfill";export default cjsm.default ?? cjsm;